// Polyfill ext. spritemaps for Safari 6, IE 6+, and Edge 12
import 'svg4everybody';

import MainMenu from "../../../../src/js/components/common/MainMenu";
import SubMenus from "../../../../src/js/components/common/SubMenus";
import Search from "../../../../src/js/components/common/Search";

new MainMenu();
new SubMenus();
new Search();